import React from 'react';
import PropTypes from 'prop-types';
import { convertColorToThemeHexCode } from 'Styles/colors.util';

import * as Styled from './NotifyDialogSuccess.styled';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';

/**
 * A success confirmation screen for submitting an email address for a notification
 */
const NotifyDialogSuccess = ({ image, onOkayClick }) => (
  <>
    <Styled.Title data-testid="NotifyDialogTitle">You’re All Set</Styled.Title>
    <Styled.Subtitle data-testid="NotifyDialogSubtitle">
      You will be notified when this item is back in stock.
    </Styled.Subtitle>
    <Styled.ImageContainer>
      <ResponsiveImage
        src={image.src}
        alt={image.alt}
        background={convertColorToThemeHexCode('grey40')}
        resolution={{
          small: 240
        }}
      />
    </Styled.ImageContainer>
    <Styled.Button isFull variant="primary" onClick={onOkayClick} type="button">
      Okay
    </Styled.Button>
  </>
);

NotifyDialogSuccess.propTypes = {
  /**
   * callback to run when the "okay" button is clicked
   */
  onOkayClick: PropTypes.func,
  /**
   * Image of the product variant
   */
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }).isRequired
};

NotifyDialogSuccess.defaultProps = {
  onOkayClick: () => {}
};

export default NotifyDialogSuccess;
